export const szpLightTheme = {
  dark: false,
  colors: {
    primary: '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    szGrey: '#414345',
    szLightGrey: '#9DA0A1',
    szRed: '#ED1C24',
    loadingRed: '#EE6F66',
    szViolet: '#6C83FF'
  }
}
